import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";

export function useTeam() {
  const [team, setTeam] = useState([]);
  useEffect(() => { api.get("/users").then((r) => setTeam(r.data.filter((x) => x.active !== false))).catch(() => {}); }, []);
  return team;
}

export const copyText = (text, t) => navigator.clipboard?.writeText(text).then(() => toast.success(t("Copied", "Copiado")), () => toast.error(t("Copy failed", "No se pudo copiar")));

export const CONN = {
  connected: ["Connected", "Conectado", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  waiting: ["Waiting for first lead", "Esperando primer prospecto", "bg-amber-50 text-amber-700 border-amber-200"],
  error: ["Error", "Error", "bg-red-50 text-red-700 border-red-200"],
  disconnected: ["Disconnected", "Desconectado", "bg-slate-100 text-slate-500 border-slate-200"],
};

export const ConnBadge = ({ status, lang, testid }) => {
  const [en, es, cls] = CONN[status] || CONN.disconnected;
  return <span className={`text-xs font-semibold border rounded-full px-2 py-0.5 shrink-0 ${cls}`} data-testid={testid}>{lang === "es" ? es : en}</span>;
};

export const PreviewWarning = ({ t }) => (
  <div className="text-xs font-semibold rounded-lg border border-amber-300 bg-amber-50 text-amber-800 p-2" data-testid="lead-preview-warning">
    {t("This is the PREVIEW (test) app. Google Ads cannot use this address. Open your published app at https://app.hcalixpainting.com, connect the source there and use that Webhook URL and Key.", "Esta es la app de VISTA PREVIA (prueba). Google Ads no puede usar esta dirección. Abra su app publicada en https://app.hcalixpainting.com, conecte la fuente allí y use esa URL y Clave.")}
  </div>
);
